// src/components/demo/DemoAcquisitionSection.jsx
import React from "react";
import { FaRegHandshake, FaRegFileAlt, FaRegPlayCircle } from "react-icons/fa";

const steps = [
  {
    icon: FaRegHandshake,
    title: "1. Prise de contact",
    desc: "Vous me contactez par téléphone ou par mail, nous échangeons sur la taille de votre commune, vos besoins et vos priorités, puis nous planifions une démonstration personnalisée de MonAppliMairie.",
  },
  {
    icon: FaRegFileAlt,
    title: "2. Paramétrage de votre site",
    desc: "Après la réservation ou la configuration de votre nom de domaine, j’installe MonAppliMairie et paramètre votre commune (logo, couleurs, services, premiers contenus). Il faut en général entre 1 et 2 heures pour que le site soit en ligne et pleinement fonctionnel (propagation du nom de domaine comprise).",
  },
  {
    icon: FaRegPlayCircle,
    title: "3. Formation & accompagnement",
    desc: "Je peux organiser une ou plusieurs visio de formation pour le personnel municipal (secrétariat, communication, élus…). Et surtout, je reste disponible : vous pouvez me solliciter à tout moment, je réponds à vos demandes 24h/24 par mail ou par téléphone.",
  },
];

export default function DemoAcquisitionSection() {
  return (
    <section
      id="presentation"
      className="mx-auto max-w-[1200px] px-4 sm:px-6 mt-16"
    >
      <Header
        title="Comment obtenir MonAppliMairie ?"
        subtitle="Un accompagnement clé en main, de la première prise de contact à la mise en ligne"
      />

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {steps.map((step, idx) => {
          const Icon = step.icon;
          const isFirst = idx === 0;

          return (
            <div
              key={step.title}
              className="group relative overflow-hidden rounded-2xl border border-slate-200/70 dark:border-slate-700/80 bg-white/90 dark:bg-slate-900/80 shadow-sm p-6 md:p-7 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              {/* Fond dégradé subtil */}
              <div className="pointer-events-none absolute inset-0 opacity-60 mix-blend-soft-light">
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-gradient-to-br from-sky-500/30 via-indigo-500/20 to-emerald-500/30 blur-2xl" />
                <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-gradient-to-br from-amber-500/30 via-pink-500/20 to-purple-500/30 blur-2xl" />
              </div>

              <div className="relative">
                <div className="flex items-center gap-4">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-gradient-to-br from-sky-500/15 via-primary/20 to-purple-500/20 text-primary group-hover:scale-105 group-hover:rotate-1 transition-transform duration-300">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="text-xs uppercase font-semibold text-slate-500 dark:text-slate-400 tracking-wide">
                    Étape {idx + 1}
                  </div>
                </div>

                <h3 className="mt-4 text-lg font-semibold text-slate-900 dark:text-slate-100">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                  {step.desc}
                </p>

                {/* CTA spécifiques sur la première étape */}
                {isFirst && (
                  <div className="mt-4 flex flex-wrap gap-2">
                    <a
                      href="tel:0680727707"
                      className="inline-flex items-center justify-center px-3 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide text-white shadow-sm hover:shadow-md transition-shadow"
                      style={{ backgroundColor: "#0d72a2" }}
                    >
                      Appeler le 06 80 72 77 07
                    </a>
                    <a
                      href="mailto:contact@monapplimairie.com"
                      className="inline-flex items-center justify-center px-3 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide text-white shadow-sm hover:shadow-md transition-shadow"
                      style={{ backgroundColor: "#fc841e" }}
                    >
                      Envoyer un e-mail
                    </a>
                    <a
                      href="#contact"
                      className="inline-flex items-center justify-center px-3 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide border border-slate-300/70 dark:border-slate-600/80 text-slate-700 dark:text-slate-100 bg-white/70 dark:bg-slate-900/70 hover:bg-white/90 dark:hover:bg-slate-800"
                    >
                      Formulaire de contact
                    </a>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

function Header({ title, subtitle }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 text-center">
      <div className="inline-flex items-center gap-2 rounded-full bg-primary/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-primary">
        <span>Processus d’acquisition</span>
      </div>
      <div>
        <h2 className="text-3xl md:text-[34px] font-semibold tracking-wide">
          {title}
        </h2>
        <p className="text-sm text-muted mt-1 max-w-2xl">
          {subtitle}
        </p>
      </div>
    </div>
  );
}
